export const FORM_FIELDS = {
   CSS_CLASS: 'cssClass',
   CSS_STYLE: 'cssStyle',
   NODE_POS: 'nodePos',
} as const;